// Константы эндпоинтов API

export const API_ENDPOINTS = {
  // Публичные эндпоинты
  publicProfile: (slug: string) => `/public/${slug}/profile`,
  publicServices: (slug: string) => `/public/${slug}/services`,
  publicProducts: (slug: string) => `/public/${slug}/products`,
  publicAvailability: (slug: string) => `/public/${slug}/availability`,
  publicCalendarAvailability: (slug: string) => `/public/${slug}/calendar-availability`,
  publicAppointments: (slug: string) => `/public/${slug}/appointments`,
  cancelAppointment: (id: string) => `/public/appointments/${id}/cancel`,
  rescheduleAppointment: (id: string) => `/public/appointments/${id}/reschedule`,
  publicManageAppointment: (id: string) => `/public/appointments/${id}/manage`,
  publicManageChannels: (token: string) => `/public/manage/${encodeURIComponent(token)}/notification-channels`,
  publicManageByShortCode: (shortCode: string) => `/public/manage/short-code/${shortCode}`,
  publicVkUser: (slug: string, vkUserId: string) => `/public/${slug}/vk-user/${vkUserId}`,
  publicClientByVk: (slug: string, vkUserId: string) => `/public/${slug}/client-by-vk/${vkUserId}`,
  publicCheckPhone: (slug: string) => (phone: string) => `/public/${slug}/check-phone?phone=${encodeURIComponent(phone)}`,
  publicBookingContext: (slug: string) => (phone: string) => `/public/${slug}/booking-context?phone=${encodeURIComponent(phone)}`,
} as const;
